var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0491 9.40796L11.7657 4.69962C11.8432 4.62152 11.9354 4.55952 12.0369 4.51721C12.1385 4.47491 12.2474 4.45312 12.3574 4.45312C12.4674 4.45312 12.5763 4.47491 12.6779 4.51721C12.7794 4.55952 12.8716 4.62152 12.9491 4.69962C13.1043 4.85576 13.1914 5.06697 13.1914 5.28712C13.1914 5.50728 13.1043 5.71849 12.9491 5.87462L8.8241 10.0413L12.9491 14.1663C13.1043 14.3224 13.1914 14.5336 13.1914 14.7538C13.1914 14.9739 13.1043 15.1852 12.9491 15.3413C12.8719 15.42 12.7799 15.4827 12.6783 15.5256C12.5767 15.5685 12.4677 15.5908 12.3574 15.5913C12.2472 15.5908 12.1381 15.5685 12.0365 15.5256C11.935 15.4827 11.8429 15.42 11.7657 15.3413L7.0491 10.633C6.9645 10.5549 6.897 10.4602 6.8508 10.3548C6.8046 10.2494 6.7808 10.1355 6.7808 10.0205C6.7808 9.90538 6.8046 9.79153 6.8508 9.68612C6.897 9.5807 6.9645 9.48599 7.0491 9.40796Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.3c162c4d7561b911a266a29e5fc7ed54.svg";
export { ForwardRef as ReactComponent };